// extracted by mini-css-extract-plugin
export default {"main":"Preloader_main__XQJai","leftSide":"Preloader_leftSide__eeHZY","rightSide":"Preloader_rightSide__EoR90","load":"Preloader_load__w6D+I"};